type CompanyModuleMap = Record<string, boolean | undefined> | null | undefined;

type CompanyModuleCarrier = {
  role?: string | null;
  company?: {
    modules?: CompanyModuleMap;
    explicitModules?: string[] | null;
  } | null;
} | null | undefined;

const normalizeRole = (role?: string | null) => String(role || '').trim().toLowerCase();

const normalizeModuleKey = (moduleKey: string) => String(moduleKey || '').trim();

export function isCompanyModuleEnabled(user: CompanyModuleCarrier, moduleKey: string) {
  const normalizedKey = normalizeModuleKey(moduleKey);
  if (!normalizedKey) return false;

  if (normalizeRole(user?.role) === 'superadmin') {
    return true;
  }

  const company = user?.company;
  const modules = company?.modules;

  if (modules && Object.prototype.hasOwnProperty.call(modules, normalizedKey)) {
    return modules[normalizedKey] === true;
  }

  return false;
}
